// ----------------------------------------------------------------------

export default function Accordion() {
  return {
    MuiAccordion: {
      styleOverrides: {
        root: {
          '&.Mui-expanded': {
            boxShadow: 0,
            borderRadius: 5,
          },
          '&.Mui-disabled': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            opacity: 1,
            '& .MuiTypography-root': {
              color: 'inherit',
            },
          },
        },
        content: {
          '&.MuiAccordionSummary-content': {
            margin: 0,
          },
        },
        expandIconWrapper: {
          color: 'inherit',
        },
      },
    },
  };
}
